import Error from "../utils/Error.js";
import global from "../global.js";

const log = global.log.getLogger("f_mtac.server.administration");
log.setLevel(log.levels.WARN);

let Administration = function(server) {
    this.authenticated = false;

    this.login = ({passphrase, org_id}) => {
        return server.post("/admin/login", {passphrase, org_id}, {
            401: (error) => {
                throw new Error.build.access({
                    message: "failed to login",
                    data: {error}
                });
            }
        }).then(response => {
            this.authenticated = true;
            return response.json();
        });
    };

    this.authenticate = ({passphrase}) => {
        const org_id = global.configuration.commissioning.organization;
        return server.post("/admin/auth", {passphrase, org_id}, {
            401: (error) => {
                throw new Error.build.access({
                    message: "failed to authenticate",
                    data: {error}
                });
            }
        }).then(response => {
            this.authenticated = true;
            return response.json();
        });
    };

    this.logout = () => {
        return server.post("/admin/logout", {}, {
            401: () => {
                // reload the page to display the superadmin login page
                window.document.location.reload();
            }
        }).then(response => {
            this.authenticated = false;
            return response.json();
        });
    };

    this.user_list = ({from, limit}) => {
        return server.get("/admin/user", {from, limit}, {
            401: () => {
                        // reload the page to display the admin login page
                        window.document.location.reload();
            }
        }).then(response => response.json());
    };

    this.user_deregister = ({login}) => {
        return server.delete("/admin/user", {login}, {
            401: () => {
                // reload the page to display the admin login page
                window.document.location.reload();
            }
        }).then(response => response.json());
    };

    this.user_disconnect = ({login}) => {
        return server.delete("/admin/user/session", {login}, {
            401: () => {
                // reload the page to display the admin login page
                window.document.location.reload();
            }
        }).then(response => response.json());
    };

    this.admin_passphrase = ({org_id, old_password, new_password}) => {
        return server.post("/admin/passphrase", {org_id, old_password, new_password}, {
            401: (error) => {
                throw new Error.build.access({
                    message: "failed to authenticate",
                    data: {error}
                });
            }
        }).then(response => response.json());
    };

    this.enrollment_passphrase = ({admin_password, new_password}) => {
        return server.post("/admin/enrollpassphrase", {admin_password, new_password}, {
            401: (error) => {
                throw new Error.build.access({
                    message: "failed to authenticate",
                    data: {error}
                });
            }
        }).then(response => response.json());
    };

    this.admin_users_export = () => {
        return server.get("/admin/user/export", {}, {
            401: () => {
                // reload the page to display the admin login page
                window.document.location.reload();
            }
        }).then(response => response.blob());
    };

    this.admin_users_import = ({import_data}) => {
        return server.upload("/admin/user/import", {import_data}, {
            401: () => {
                // reload the page to display the admin login page
                window.document.location.reload();
            }
        }).then(response => response.json());
    };

    this.load_organization_settings = ({org_id}) => {
        return server.get("/admin/organization", {org_id}, {
            401: () => {
                // reload the page to display the admin login page
                window.document.location.reload();
            }
        }).then(response => response.json());
    };

    this.update_organization_settings = ({org_id, org_name, gis_type, gis_key, grid, center_lon, center_lat}) => {
        return server.post("/admin/organization", {org_id, org_name, gis_type, gis_key, grid, center_lon, center_lat}, {
            401: () => {
                // reload the page to display the admin login page
                window.document.location.reload();
            }
        }).then(response => response.json());
    };

};
export default Administration;
